import React, { useEffect, useState, useRef } from 'react';
import { Alert, Button, Form, Input, Space } from 'antd';
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import HTTPService from "../../utils/makerequest";

import { StateLoader } from '../../redux/StateLoader';
import { Toast } from 'primereact/toast';
import { UserRole } from '../../interfaces/authentication';
import '../../i18n';
import { t } from 'i18next';
import AltisFirebase from '../../firebase/firebase';

const SingInForm: React.FC<any> = (props) => {
    const [visible, setVisible] = useState(false);
    const [token, setToken] = useState(null);
    const toast = useRef<any>(null);
    const loader = new StateLoader();
    const handleClose = () => {
        setVisible(false);
    };

    useEffect(() => {
        const fetchToken = async () => {
            const tokenValue = await (new AltisFirebase).generateToken();
            setToken(tokenValue);
        };
        if (window.location.protocol === 'https:') {
            fetchToken();
        }
    }, []);

    const login = async (e) => {
        const isWeb = true;

        let user = { email: e.email, pass: e.password, token, isWeb };
        HTTPService.LOGIN(`/Login`, user)
            .then((response) => {
                if (response.status === 200) {
                    if (response.data.role === UserRole.Sayman) {
                        toast.current?.show({
                            severity: 'error',
                            summary: t('errors'),
                            detail: t('authority'),
                            life: 3000
                        });
                        return;
                    }
                    loader.saveAuthState(response.data)
                    toast.current?.show({
                        severity: 'success',
                        summary: t('successful'),
                        detail: t('login'),
                        life: 3000
                    });
                    window.location.replace('/admin/dashboard/');
                }
                else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: response.data,
                        life: 3000
                    });
                }

            })
            .catch((error) => {
                console.error('Login failed:', error);
                setVisible(true);
            });
    }

    return (
        <>
            <Toast ref={toast} />
            <Form style={{ width: '100%' }} onFinish={login}>
                {visible && (<Space direction="vertical" style={{ width: '100%', marginBottom: '10px' }}>
                    <Alert message="email or password wrong!" type="error" closable afterClose={handleClose} />
                </Space>)}
                <Form.Item name='email'
                    rules={[{ required: true, message: t('please_input_email'), whitespace: true }]}>
                    <Input
                        prefix={<UserOutlined />}
                        placeholder={t('email')}
                        style={{ borderRadius: 0 }}
                    />
                </Form.Item>
                <Form.Item name='password'
                    rules={[{ required: true, message: t('inputPassword') }]}>
                    <Input.Password
                        prefix={<LockOutlined />}
                        placeholder={t('password')}
                        style={{ borderRadius: 0 }} />
                </Form.Item>
                <Form.Item>
                    <div className="d-flex flex-column align-items-center justify-content-center" style={{ width: '100%' }}>
                        <Button htmlType="submit" type="primary" style={{ width: '60%', marginBottom: '15px', marginLeft: '75px', borderRadius: '5px' }}>
                            {t('sign')}
                        </Button>
                        <Button htmlType="button" type="default" style={{ width: '60%', borderRadius: '5px', marginLeft: '75px' }}
                            onClick={() => {
                                window.location.replace('/public/forgot-password/');
                            }}>
                            {t('forgot')}
                        </Button>
                    </div>
                </Form.Item>

            </Form>
        </>
    );
};

export default SingInForm;
